<template>
  <div class="pdf-reports" v-click-outside="onClickOutsidePdfList">
    <div class="close-pdf-report" @click="closePdfReports()">
      <img src="@img/close-gray.svg" alt="">
    </div>
    <div class="pdf-reports__content">
      <div class="pdflist-table">
        <h2 class="report-name">{{ getSelectedReportName() }}</h2>
        <span class="report-id">{{ selectedOrder.order_number }}</span>
        <div class="pdflist-table-row pdf-reports__content__header">
          <div class="pdf-reports__content__header-item pdf-item-name">{{locale === 'en' ? 'Name' : 'Название'}}</div>
          <div class="pdf-reports__content__header-item pdf-item-created">{{locale === 'en' ? 'Created' : 'Создан'}}</div>
          <div class="pdf-reports__content__header-item pdf-item-status">{{locale === 'en' ? 'Status' : 'Статус'}}</div>
          <div class="pdf-reports__content__header-item pdf-item-download">{{locale === 'en' ? 'Download' : 'Скачать'}}</div>
        </div>

        <div class="loading">
          <div v-show="loadingPdfList" class="loading-tr">
            <div class="shine loading-td"></div>
          </div>
          <div v-show="loadingPdfList" class="loading-tr">
            <div class="shine loading-td"></div>
          </div>
          <div v-show="loadingPdfList" class="loading-tr">
            <div class="shine loading-td"></div>
          </div>
          <div v-show="loadingPdfList" class="loading-tr">
            <div class="shine loading-td"></div>
          </div>
          <div v-show="loadingPdfList" class="loading-tr">
            <div class="shine loading-td"></div>
          </div>
          <div v-show="loadingPdfList" class="loading-tr">
            <div class="shine loading-td"></div>
          </div>
        </div>

        <div v-show="!loadingPdfList && reportsList.length > 0" class="pdflist-table-row list" v-for="(item, index) in reportsList" :key="index">
          <div class="list-item pdf-item-name"> <span class="m-title">Название:</span> {{ item.name !== '' && item.name !== undefined && item.name !== null ? item.name : 'Отчет' }}</div>
          <div class="list-item pdf-item-created"> <span class="m-title">Создан:</span> {{ makeCalculate(item.created_at) }}</div>
          <div class="list-item pdf-item-status"> <span class="m-title">Статус:</span> <span :class="{'green': item.status === 'done', 'yellow': item.status === 'processing', 'red': item.status === 'failed'}" class="label-status"></span> {{ getStatusHumanName(item.status) }}</div>
          <div class="list-item download-wrapper" v-show="item.status === 'done'">
            <span class="m-title">Скачать:</span>
            <div class="pad-item-download" v-if="item.pdf">
              <button class="button-download" @click="downloadReport(item, '.pdf')">
                <i data-v-61fb690f="" class="fa fa-arrow-down i_style"></i>
                <span>PDF</span>
              </button>
            </div>
            <div class="pad-item-download" v-if="item.docx">
              <button class="button-download" @click="downloadReport(item, '.docx')">
                <i data-v-61fb690f="" class="fa fa-arrow-down i_style"></i>
                <span>DOCX</span>
              </button>
            </div>
          </div>
        </div>

        <div v-show="!loadingPdfList && reportsList.length === 0" class="empty-reports">
          <h3>Отчёты отсутствуют</h3>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import appStore from '@storages/appStore'
import reportStore from '@storages/reportStore'
import httpStore from '@storages/httpStore'

export default {
  name: 'pdf-reports',
  data () {
    return {
      reportsList: [],
      loadingPdfList: true,
      statusLabel: [
        {
          processing: 'В работе',
          done: 'Готов',
          failed: 'Ошибка'
        },
        {
          processing: 'In process',
          done: 'Done',
          failed: 'Failed'
        }
      ]
    }
  },

  computed: {
    locale () {
      return appStore.getters.value('locale')
    },
    selectedOrder () {
      return reportStore.getters.value('selectedOrder')
    },
    products () {
      return appStore.getters.value('products')
    },
    chain () {
      return reportStore.getters.value('chain')
    }
  },

  mounted () {
    this.getPDFsList()
  },

  methods: {
    getSelectedReportName () {
      if (this.chain[1].name !== '') {
        return this.chain[1].name
      } else {
        return this.getHumanProductName(this.selectedOrder)
      }
    },
    makeCalculate (created) {
      return this.$moment(created).format('DD.MM.YYYY')
    },
    getHumanProductName (selectedOrder) {
      if (selectedOrder === null) {
        return ''
      }
      if (selectedOrder.name !== undefined && selectedOrder.name !== null && selectedOrder.name !== '') {
        return selectedOrder.name
      }
      if (selectedOrder !== null && selectedOrder.product_id && this.products) {
        let productId = selectedOrder.product_id
        let _product = this.products.find(item => { return item !== null && item.product_id === productId })
        return _product.product_title
      } else {
        return ''
      }
    },
    onClickOutsidePdfList () {
      this.$emit('setShowReportsList', false)
    },
    downloadReport (item, type) {
      if ('order_id' in item && 'report_id' in item && item.status === 'done') {
        let _url = httpStore.getters.host + httpStore.getters.downloadLink(item) + type
        window.open(_url, '_blank')
      }
    },
    closePdfReports () {
      this.$emit('setShowReportsList', false)
    },
    getStatusHumanName (status) {
      if (this.locale === 'en') {
        return this.statusLabel[1][status]
      } else {
        return this.statusLabel[0][status]
      }
    },

    getPDFsList () {
      this.loadingPdfList = true
      this.getDownloadPdfListMix(this.selectedOrder.order_id).then(response => {
        this.reportsList = response.body
        this.loadingPdfList = false
      }, err => {
        console.log('fail get reports list', err)
        this.loadingPdfList = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
$table-width: 520px;
$table-width-mobile: 100%;

.i_style {
  font-size: 12px;
}

.empty-reports h3 {
  margin-top: 20px;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
}

.report-name {
  white-space: nowrap;
  text-overflow: ellipsis;
  font-weight: bold;
  font-size: 20px;
  margin-bottom: 5px;
  overflow: hidden;
}

.report-id {
  display: inline-block;
  color: #616161;
  margin-bottom: 10px;
}

.label-status {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 100%;
  margin-right: 5px;
}

.green {
  background-color: #2bac76;
}

.yellow {
  background-color: #efab61;
}

.red {
  background-color: #c42222;
}

.button-download {
  border: none;
  display: flex;
  align-items: center;
  color: #455c88;
  background-color: #dfeafc;
  border-radius: 10px;
  justify-content: space-evenly;
  padding: 10px 8px;
  transition: .3s;
  span {
    font-size: 12px;
    margin-left: 5px;
  }
  &:hover {
    background-color: #ccddfa;
  }
}

.pdf-reports {
  box-shadow: 0px 3px 16px 0 rgba(0, 0, 0, 0.13);
  border-radius: 4px;
  position: absolute;
  top: 15px;
  left: 65px;
  z-index: 6;
  max-width: 620px;
  width: 80%;
}
.pdf-reports__content {
  box-sizing: border-box;
  padding: 30px 20px 20px 30px;
  background-color: white;
}
.pdf-reports__content__header {
  border-bottom: 1px solid #616161!important;
  margin-bottom: 10px;
}
.pdf-reports__content__header-item {
  font-weight: bold;
  font-size: 16px;
  padding: 4px 0 14px;
}

.list-item {
  padding: 5px 0;
}
.pdflist-table {
  border-spacing: 7px 5px;
  border-collapse: collapse;
  margin-right: 50px
}

.pdflist-table-row,
.pdf-item-name,
.pdf-item-created,
.pdf-item-status {
  display: flex;
  align-items: center;
}

.pdf-item-name {
  flex: 0 0 35%;
  max-width: 0 0 35%;
}

.pdf-item-download {
  flex: 0 0 25%;
  max-width: 0 0 25%;
}

.pdf-item-created,
.pdf-item-status {
  flex: 0 0 20%;
  max-width: 0 0 20%;
}

.download-wrapper {
  display: flex;
  button {
    margin-right: 10px;
  }
}

.close-pdf-report {
  position: absolute;
  width: 13px;
  height: 13px;
  top: 30px;
  right: 35px;
}
.close-pdf-report:hover {
  cursor: pointer;
}
.close-pdf-report img {
  width: 100%;
}
.loading-tr {
  margin-bottom: 10px;
}

.loading-td {
  height: 40px;
  width: 100%;
  border-top: 6px solid transparent;
}

.m-title {
  display: none;
  font-weight: bold;
}

@media (min-width: 320px) and (max-width: 960px) {
  .loading-td {
    height: 130px;
    width: 100%;
    border-top: 6px solid transparent;
  }
  .m-title {
    display: inline-block;
    margin-right: 10px;
  }
  .list {
    padding-top: 10px;
    border-bottom: 1px solid #616161!important;
  }
  .list-item {
    margin: 5px 0;
  }
  .download-wrapper {
    align-items: center;
  }
  .pdf-reports {
    position: fixed;
    top: 78px;
    left: 0;
    width: 100vw;
    height: calc(100vh - 78px);
    z-index: 15;
  }
  .pdf-reports__content {
    padding: 30px 10px 40px;
    width: 100%;
    height: 100%;
    overflow-y: auto;
  }
  .pdflist-table-row,
  .pdf-item-name,
  .pdf-item-created,
  .pdf-item-status {
    display: block;
  }
  .pdf-reports__content__header {
    display: none;
  }

  .pdflist-table {
    width: $table-width-mobile
  }
  .close-pdf-report img {
    width: 100%;
  }
  .close-pdf-report {
    right: 20px;
    top: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/main/reportsPDFList.vue